import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotAlarmSetting, CreateSnapshotAlarmSettingDto } from 'types';
import { convertAlarmSettings } from 'api/dtoConverters';

export const createAlarmSettings = async ({
  data,
}: {
  data: CreateSnapshotAlarmSettingDto;
}): Promise<SnapshotAlarmSetting> => {
  const { data: createdSettings } = await axios.post(
    '/api/snapshots/alarms/snapshot-alarm-settings',
    convertAlarmSettings(data)
  );
  return createdSettings as SnapshotAlarmSetting;
};

type UseCreateAlarmSettingsOptions = {
  config?: MutationConfig<typeof createAlarmSettings>;
};

export const useCreateAlarmSettings = ({
  config,
}: UseCreateAlarmSettingsOptions = {}) => {
  return useMutation({
    onMutate: async (newAlarmSettings) => {
      await queryClient.cancelQueries(['alarms', 'settings']);

      const previousAlarmSettings =
        queryClient.getQueryData<SnapshotAlarmSetting>(['alarms']);

      queryClient.setQueryData(['alarms', 'settings'], newAlarmSettings);

      return previousAlarmSettings;
    },
    onError: (_, __, context: any) => {
      if (context?.previousAlarmSettings) {
        queryClient.setQueryData(
          ['alarms', 'settings'],
          context.previousAlarmSettings
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['alarms', 'settings']);
    },
    ...config,
    mutationFn: createAlarmSettings,
  });
};
